// import $ from "jquery"
import ReCAPTCHA from "react-google-recaptcha"
import { useForm } from "react-hook-form"
import { toast } from "react-toastify"
import { ApiData, getApiDataPromise } from "../../models/ApiData"
import OptionsApiData from "../common/OptionsApiData"

export default function AffiliateSignUp() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()
  let in_progress = false

  const onSubmit = async function (data: any) {
    if (in_progress) return

    in_progress = true

    data["g-recaptcha-response"] = $('[name="g-recaptcha-response"]').val()

    if (!data["g-recaptcha-response"]) {
      toast.error("Please fill out the reCAPTCHA!")
      return
    }

    var result = await getApiDataPromise(data, "public_data", "send_affiliate_mail")

    if (result.success) {
      toast.success("Successful!")
      $("#aff_form").hide()
    } else {
      toast.error(result.message)
      in_progress = false
    }
  }

  const onCountriesLoaded = () => {
    ApiData.clientApiRequest({}, "get_country").then((data) => {
      if (data.success) $("#country_code").val(data.data["code"])
    })
  }

  return (
    <>
      <section className="signup" id="signup">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 light">
              <h2 className="signup__title title">Sign up now & start earning with us!</h2>
            </div>
            <div className="col-lg-7 text-lg-right text-center">
              <form onSubmit={handleSubmit(onSubmit)} id={"aff_form"}>
                <div className="signup__form exchange-form box text-left">
                  <div className="signup__form_boxing">
                    <h3 className="steps__box_title">Contact information</h3>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form__item">
                          <input
                            type="text"
                            className="input input_small"
                            placeholder="First Name"
                            {...register("first_name", { required: true, minLength: 2 })}
                          />
                          {errors.first_name && <span className="erorrs">This field is required!</span>}
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form__item">
                          <input
                            type="text"
                            className="input input_small"
                            placeholder="Last Name"
                            {...register("last_name", { required: true, minLength: 2 })}
                          />
                          {errors.last_name && <span className="erorrs">This field is required!</span>}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form__item">
                          <input
                            type="text"
                            className="input input_small"
                            placeholder="Email (used for communication)"
                            {...register("email", { required: true, pattern: /^\S+@\S+$/i })}
                          />
                          {errors.email && <span className="erorrs">Please enter a valid email!</span>}
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form__item">
                          <input
                            type="text"
                            className="input input_small"
                            placeholder="Skype"
                            {...register("skype", { required: false })}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form__item form__item_nolabel">
                          <select id="country_code" className="input input_small" {...register("country_code", { required: true })}>
                            <OptionsApiData type={"country"} key_equals_value={false} onLoaded={onCountriesLoaded} />
                          </select>

                          {errors.country && <span className="erorrs">This field is required!</span>}
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form__item">
                          <input
                            type="tel"
                            className="input input_small"
                            placeholder="Phone"
                            {...register("phone", { required: true, pattern: /^[0-9+]{1,}[0-9-]{5,15}$/ })}
                          />
                          {errors.phone && <span className="erorrs">Please enter a valid phone!</span>}
                        </div>
                      </div>
                    </div>
                  </div>
                  <h3 className="steps__box_title">Tell Us about your traffic</h3>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form__item_modal">
                        <input
                          type="url"
                          className="input input_small"
                          placeholder="Website URL"
                          {...register("website", { required: true })}
                        />
                        {errors.website && <span className="erorrs">Please enter a valid url, like: http://site.com/</span>}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form__item_modal">
                        <input
                          type="text"
                          className="input input_small"
                          placeholder="Current monthly unique visitors"
                          {...register("visitors_count", { required: true })}
                        />
                        {errors.visitors_count && <span className="erorrs">This field is required!</span>}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="recapcha">
                        <ReCAPTCHA sitekey="6LcK4UIrAAAAAIyxjMXq8Xyf09FzdY2Y2M_zstuc" />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="steps__form_footer">
                        <button type="submit" className="button button_bg_red">
                          Send
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
